import { APIError } from '@atlaskit/smart-card';
import { featureFlagClient } from '@trello/feature-flag-client';

/**
 * Matches Trello URLs supported by the Object Resolver Service
 * Trello URL support is defined in the trello-object-provider service
 * {@link https://bitbucket.org/trello/trello-object-provider/src/master/src/linkResolver.ts#lines-11}
 */
const smartTrelloUrlRegExpPattern =
  '^https://(trello.com|trellis.coffee)/(c|b|invite/b|w|u)/';
const smartTrelloUrlRegExp = new RegExp(smartTrelloUrlRegExpPattern, 'i');

/**
 * Throws an APIError if the link pattern is unsupported
 * Currently used to prevent rendering of Trello urls as smart links
 * @param url
 * @returns
 */
export const assertSupportedUrlPattern = (url: string): boolean => {
  const isTrelloSmartLinkRenderingEnabled = featureFlagClient.get(
    'aaaa.web.resolve-trello-smart-links-in-trello',
    false,
  );
  if (!isTrelloSmartLinkRenderingEnabled && url.match(smartTrelloUrlRegExp)) {
    throw new APIError(
      'error',
      '',
      'Could not resolve URL.',
      'ResolveUnsupportedError',
    );
  }
  return true;
};
